import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PayTrendsIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M23 20.25H21.62V5C21.62 4.65 21.34 4.38 21 4.38H16.5C16.16 4.38 15.88 4.66 15.88 5V13.38H12.63V11C12.63 10.65 12.35 10.38 12.01 10.38H7.51001C7.16001 10.38 6.89001 10.66 6.89001 11V16.38H3.01001C2.66001 16.38 2.39001 16.66 2.39001 17V20.25H1.01001C0.60001 20.25 0.26001 20.59 0.26001 21C0.26001 21.41 0.60001 21.75 1.01001 21.75H23.01C23.42 21.75 23.76 21.41 23.76 21C23.76 20.59 23.42 20.25 23.01 20.25H23ZM20.38 5.62V20.24H17.13V5.62H20.38ZM15.88 14.62V20.24H12.63V14.62H15.88ZM11.38 11.62V20.24H8.13001V11.62H11.38ZM3.62001 17.62H6.87001V20.24H3.62001V17.62Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

PayTrendsIcon.displayName = 'PayTrendsIcon';
